import React from 'react';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom } from '../../../utils/util';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Dropdown, Row, Col, Modal, Button } from 'react-materialize';
import ButtonUI from '../../../components/UI/ButtonUI';
import PlantService from '../../../services/PlantService';
import { isNullOrEmpty, formatData, getUserNameToName } from '../../../utils/util';
import { Input } from '../../../components/UI/ComponentsUI';

const PlantListItem = (props) => {
    const onConfirm = (plant) => {
        props.plantDelete(plant, (response) => {
            if (!response) {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-delete', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                props.history.go(-1);
            }
        });
    };

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '8px', right: '5px', zIndex: '999' }}
            >
                <Row>
                    <Col className="col s12" style={{ padding: 0 }}>
                        <Dropdown
                            id={`DropdownFloating_${props.data.plantId}`}
                            options={{ constrainWidth: false, belowOrigin: true }}
                            trigger={
                                <i className="material-icons sixth-text-color" style={{ fontSize: '1.75rem' }}>more_vert</i>
                            }>
                            <Link
                                key={`dpl-01`}
                                to={{ pathname: '../area', state: { plantId: props.data.plantId } }}
                                onClick={(event) => {
                                    if (props.onSelectChange) {
                                        props.onSelectChange(event);
                                    }
                                }}
                            >
                                <span className="truncate sixth-text-color">
                                    <i className="mdi mdi-archive" /> {translate('title', 'area')}
                                </span>
                            </Link>
                        </Dropdown>
                    </Col>
                    <Col className="col s12" style={{ padding: 0 }}>
                        <Modal
                            id={`modal-id-${props.data.plantId}`}
                            fixedFooter
                            style={{ marginTop: "15px", maxHeight: "60%" }}
                            actions={
                                <Row className="center" style={{ height: "60%" }}>
                                    <Button className="col s6 btn waves-effect waves-light btn-flat" modal="close">
                                        {translate('cancel', 'general')}
                                    </Button>
                                    <ButtonUI onClick={() => onConfirm(props.data)} text={translate('confirm', 'general')} />
                                </Row>
                            }
                            trigger={
                                <i className="material-icons sixth-text-color" style={{ fontSize: '1.75rem', cursor: 'pointer' }}>delete</i>
                            }>
                            <div>
                                <Row className="center">
                                    <div className="sixth-text-color center">
                                        <span className="col s12">
                                            <i className="material-icons large">info_outline</i>
                                        </span>
                                        <span className="title col s12">{translate('messages.confirmation-delete', 'plant')}</span>
                                        <span className="col s12" style={{ marginTop: '10px' }}>{translate('fields.name', 'plant')}: {`${props.data.name}`}</span>
                                        <span className="col s12">{translate('fields.latitude', 'plant')}: {`${isNullOrEmpty(props.data.latitude) ? "" : props.data.latitude}`}</span>
                                        <span className="col s12">{translate('fields.longitude', 'plant')}: {`${isNullOrEmpty(props.data.longitude) ? "" : props.data.longitude}`}</span>
                                    </div>
                                </Row>
                            </div>
                        </Modal>
                    </Col>
                    <Col className="col s12" style={{ padding: 0 }}>
                        <span style={{ position: 'absolute', paddingLeft: '4px' }}>
                            <Input 
                                type="checkbox" 
                                id="selectForDeletion"
                                onChange={() => {
                                    props.onCheck(props.data);
                                }} 
                            />
                        </span>
                    </Col>
                </Row>
            </span>
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">{`${props.data.name}`}</span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-map-marker-radius-outline" /> {`${translate('fields.latitude', 'plant')} ${isNullOrEmpty(props.data.latitude) ? "" : props.data.latitude}`}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-map-marker-radius-outline" /> {`${translate('fields.longitude', 'plant')} ${isNullOrEmpty(props.data.longitude) ? "" : props.data.longitude}`}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {getUserNameToName(props?.usersFromElog, props.data.updatedBy)}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-history" /> {formatData(props.data?.updatedOn)}
                </span>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        plant: state.plantReducer.plant, 
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        plantDelete: (plant, callback) => {
            dispatch(PlantService.DeletePlant(plant.plantId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PlantListItem)));
